export function getAlertUploadRequirementId(alert) {
  if (alert?.upload_requirement_id) return alert.upload_requirement_id;
  if (alert?.type === 'training') return `training_${alert.training_id || 'general'}`;
  if (alert?.type === 'dbs') return 'dbs_renewal';
  if (alert?.type === 'rtw') return 'rtw_renewal';
  return null;
}

export function alertSupportsWorkerUpload(alert) {
  if (alert?.can_upload === false) return false;
  if (alert?.can_upload === true) return true;
  return ['training', 'dbs', 'rtw'].includes(alert?.type);
}

export function buildComplianceDueAlerts(alerts) {
  return (alerts || []).filter(
    (alert) => alertSupportsWorkerUpload(alert) || ['competency_review', 'appraisal'].includes(alert?.type)
  );
}